export const websiteRoutes = [
  {
    path: "/website",
    name: "website",
    mata: {
      KeepAlive: true
    },
    children: [
      {
        path: "webinfo/infoManagement",
        name: "webinfo_infoManagement" ,
        component: () => import('@/view/business/website/webinfo/infoManagement.vue'),
        meta: {
          KeepAlive: true,
          hasNav: true
        }
      },
      {
        path: "webvideo/videoManagement",
        name: "webvideo_videoManagement" ,
        component: () => import('@/view/business/website/webvideo/videoManagement.vue'),
        meta: {
          KeepAlive: true,
          hasNav: true
        }
      }
    ]
  }
];